(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 88701:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(41658);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./src/components/legacy/index.ts + 40 modules
var legacy = __webpack_require__(92291);
// EXTERNAL MODULE: ./src/views/Article/index.ts + 9 modules
var Article = __webpack_require__(80233);
// EXTERNAL MODULE: ./src/views/Category/index.tsx + 1 modules
var Category = __webpack_require__(52921);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/components/pages/ProductList/ProductListPage.tsx
var ProductListPage = __webpack_require__(39569);
// EXTERNAL MODULE: ./src/hooks/useAttributesFiltering.ts
var useAttributesFiltering = __webpack_require__(79114);
// EXTERNAL MODULE: ./src/hooks/useProductFiltering.ts
var useProductFiltering = __webpack_require__(27698);
// EXTERNAL MODULE: ./src/hooks/useProductLoading.tsx
var useProductLoading = __webpack_require__(66015);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
;// CONCATENATED MODULE: ./src/views/Collection/CollectionView.tsx


// @ts-ignore unused








var CollectionView = function(param) {
    var collection = param.data;
    var ref, ref1, ref2;
    var attributes = (0,useAttributesFiltering/* useAttributesFiltering */.K)({
        collectionId: collection === null || collection === void 0 ? void 0 : collection.id
    });
    var ref3 = (0,useProductFiltering/* default */.Z)(), filters = ref3.filters, pricesFilter = ref3.pricesFilter, locationFilter = ref3.locationFilter, handleClearFilters = ref3.handleClearFilters, handleFiltersChange = ref3.handleFiltersChange, handlePricesFilter = ref3.handlePricesFilter, handleLocationFilter = ref3.handleLocationFilter, handleDeliveryFilter = ref3.handleDeliveryFilter, deliveryFilter = ref3.deliveryFilter, handleOrderChange = ref3.handleOrderChange, hasDeliveryFilter = ref3.hasDeliveryFilter, clientFiltered = ref3.clientFiltered, keyword = ref3.keyword, setKeyword = ref3.setKeyword;
    var ref4 = (0,useProductLoading/* useProductLoading */.v)({
        ssrData: null,
        ids: {
            collectionId: collection === null || collection === void 0 ? void 0 : (ref = collection.details) === null || ref === void 0 ? void 0 : ref.id
        },
        filters: filters,
        hasDeliveryFilter: hasDeliveryFilter,
        clientFiltered: clientFiltered,
        queryType: (collection === null || collection === void 0 ? void 0 : collection.details.isWarehouseSaleCollection) && (collection === null || collection === void 0 ? void 0 : collection.details.hasActiveSale) ? "warehouse_sale" : "default"
    }), products = ref4.products, loading = ref4.loading, pageInfo = ref4.pageInfo, numberOfProducts = ref4.numberOfProducts, handleLoadMore = ref4.handleLoadMore, loadMoreError = ref4.loadMoreError;
    var canonicalRef = collection && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
            rel: "canonical",
            href: "".concat(constants/* siteUrl */.or).concat(paths/* paths.categoryBase */.H.categoryBase).concat(collection.details.slug)
        })
    });
    return collection ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(legacy.MetaWrapper, {
        meta: {
            description: collection.details.seoDescription || "",
            title: collection.details.seoTitle || "",
            type: "product.collection",
            image: (ref1 = collection.details) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.backgroundImage) === null || ref2 === void 0 ? void 0 : ref2.url,
            url: constants/* ssrMode */.$m ? __webpack_require__.g.location.href : window.location.href
        },
        children: [
            canonicalRef,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductListPage/* ProductListPage */.L, {
                title: collection.details.name,
                aboveProductsDescription: collection.details.aboveProductsDescription ? collection.details.aboveProductsDescription : collection.details.seoDescription || "",
                textContent: collection.details.description,
                attributes: attributes,
                numberOfProducts: numberOfProducts,
                clearFilters: handleClearFilters,
                displayLoader: !products.length && loading,
                hasNextPage: !!(pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage),
                activeSortOption: filters.sortBy,
                filters: filters,
                products: products,
                onAttributeFiltersChange: handleFiltersChange,
                onLoadMore: handleLoadMore,
                loadMoreError: loadMoreError,
                activeFilters: Object.keys((filters === null || filters === void 0 ? void 0 : filters.attributes) || {}).length,
                onOrder: handleOrderChange,
                pricesFilter: pricesFilter,
                setPricesFilter: handlePricesFilter,
                locationFilter: locationFilter,
                setLocationFilter: handleLocationFilter,
                deliveryFilter: deliveryFilter,
                setDeliveryFilter: handleDeliveryFilter,
                keyword: keyword,
                setKeyword: setKeyword,
                hasCollectionSale: collection.details.hasActiveSale,
                isWarehouseSaleCollection: collection.details.isWarehouseSaleCollection,
                warehouseSaleTitle: collection.details.warehouseSaleTitle,
                isFetching: loading
            })
        ]
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.NotFound, {});
};

;// CONCATENATED MODULE: ./src/views/Collection/index.ts


;// CONCATENATED MODULE: ./src/views/Dynamic/DynamicView.tsx







var DynamicView = function(props) {
    var viewType = props.viewType, otherProps = (0,_object_without_properties/* default */.Z)(props, [
        "viewType"
    ]);
    if (viewType === "article") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Article/* ArticleView */.G, (0,_object_spread/* default */.Z)({}, otherProps));
    }
    if (viewType === "category") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Category/* CategoryView */.I, (0,_object_spread/* default */.Z)({}, otherProps));
    }
    if (viewType === "collection") {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionView, (0,_object_spread/* default */.Z)({}, otherProps));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(legacy.NotFound, {});
};

;// CONCATENATED MODULE: ./src/views/Dynamic/index.ts


;// CONCATENATED MODULE: ./src/pages/[...slug].ts

var __N_SSP = true;
/* harmony default export */ var _slug_ = (DynamicView);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4738,594,3662,4396,4817,8527,8547,1664,1448,5534,7947,4273,2036,9170,3920,7801,5861,8557,7629,6659,233,9774,2888,179], function() { return __webpack_exec__(88701); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);